import React, { useState, useEffect } from "react";
import { Image } from "react-native";
import Modal from "modal-react-native-web";
import {
  Typography,
  Stack,
  Box,
  Spacer,
  Divider,
  OldButton as Button,
} from "digiwash-components";
import { ScrollView } from "react-native";
import { isInStandaloneMode, isIos } from "../../helpers/general";

function crossPlatformAssetImport(filename) {
  let asset = require(`../../resources/${filename}`);
  return asset?.default || asset;
}

async function setAsHideForNextVisits() {
  return window.localStorage.setItem("iOSBannerVisibility", "1");
}

async function hasBeenShownBefore() {
  let visibility = await window.localStorage.getItem("iOSBannerVisibility");

  return !!visibility && visibility === "1";
}

function IOSInstallationBanner() {
  let [hide, setHide] = useState(true);

  useEffect(() => {
    if (isIos() && !isInStandaloneMode()) {
      hasBeenShownBefore().then((shownBefore) => {
        if (!shownBefore) {
          setHide(false);
        }
      });
    }
  }, []);

  if (hide) {
    return null;
  }

  return (
    <Modal>
      <ScrollView>
        <Stack
          p="l"
          direction="vertical"
          distribution="center"
          alignment="center"
          style={{
            width: "100%",
            maxWidth: 768,
            marginRight: "auto",
            marginLeft: "auto",
            minHeight: "100vh",
          }}
        >
          <Image
            source={crossPlatformAssetImport("logo-symbol.svg")}
            style={{ width: 48, height: 48 }}
          />
          <Divider size="xl" />
          <Typography
            ff="mainBold"
            fs="l"
            alignment="center"
            color="common.black"
          >
            وب اپلیکیشن دیجی‌واش را به صفحه اصلی موبایل خود اضافه کنید.
          </Typography>
          <Divider size="xl" />
          <Divider size="xl" />
          <Box>
            <Stack>
              <Image
                source={crossPlatformAssetImport("share-button.svg")}
                style={{ width: 24, height: 24 }}
              />
              <Spacer size="m" />
              <Typography color="common.black">
                ۱ - در نوار پایین روی دکمه <b>&nbsp;Share&nbsp;</b> تپ کنید.
              </Typography>
            </Stack>
            <Divider size="l" />
            <Stack>
              <Image
                source={crossPlatformAssetImport("add-button.svg")}
                style={{ width: 24, height: 24 }}
              />
              <Spacer size="m" />
              <Typography color="common.black">
                ۲ - در منوی باز شده، در قسمت پایین، گزینه{" "}
                <b>&nbsp;Add to Home Screen&nbsp;</b> را انتخاب کنید.
              </Typography>
            </Stack>
            <Divider size="l" />

            <Stack>
              <Image
                source={crossPlatformAssetImport("add-text-button.svg")}
                style={{ width: 24, height: 24 }}
              />
              <Spacer size="m" />
              <Typography color="common.black">
                ۳ - در مرحله بعد در قسمت بالا روی <b>&nbsp;Add&nbsp;</b>
                تپ کنید.
              </Typography>
            </Stack>
            <Divider size="xl" />
            <Divider size="xl" />
            <Button
              onPress={() => {
                setHide(true);
                setAsHideForNextVisits();
              }}
              size="m"
              bg="green.main"
              type="rounded"
            >
              <Stack distribution="center">
                <Typography color="common.white" ff="mainBold">
                  متوجه شدم
                </Typography>
              </Stack>
            </Button>
          </Box>
        </Stack>
      </ScrollView>
    </Modal>
  );
}

export default IOSInstallationBanner;
